module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki12_pc-85a2edb0721a034161bfe1a66b6f935c.jpg";